export default "__VITE_ASSET__DM87x66o__"